import springApi from '../../services/springApi'

export const getCompetitorRates = params => (
	new Promise((resolve, reject) => {
		springApi()
			.get('/competitor_rates', { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const storeCompetitorRate = data => (
	new Promise((resolve, reject) => {
		springApi()
			.post('/competitor_rates', data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const updateCompetitorRate = (id, data) => (
	new Promise((resolve, reject) => {
		springApi()
			.put(`/competitor_rates/${id}`, data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const deleteCompetitorRate = id => (
	new Promise((resolve, reject) => {
		springApi()
			.delete(`/competitor_rates/${id}`)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)